import { useMemo } from 'react'

export const useProcessedPautaItems = (contentData, unidades) => {
    const processedContentData = useMemo(() => {
        if (!contentData || contentData.length === 0 || !unidades || unidades.length === 0) {
            return []
        }

        return contentData.map(item => {
            const newItem = { ...item } // Create a shallow copy to ensure immutability

            newItem.isRequerido = false
            newItem.imagen = false

            const unidadesFiltradas = unidades.filter(u => u.idUnidad === newItem.unidad)
            if (unidadesFiltradas && unidadesFiltradas[0]) {
                newItem.inputCantidad = 1
                if (unidadesFiltradas[0].inputRequerido === 'TRUE') {
                    newItem.inputCantidad = unidadesFiltradas[0].inputCantidad
                }
            }

            const obs01 = newItem.obs01 || ''

            if (obs01.includes('Anotar la medida obtenida')) {
                if (obs01.includes('pulg')) {
                    newItem.unidad = 'pulg'
                }
                if (obs01.includes('mm')) {
                    newItem.unidad = 'MM'
                }
            }

            if (obs01.includes('foto') || obs01.includes('imágen') || obs01.includes('imagen')) {
                newItem.imagen = true
            }

            return newItem
        })
    }, [contentData, unidades])

    return processedContentData
}
